<div class="container">
  <img class="no-notes-img" src="assets\images\no-goal.png" />
  <div class="no-note-next">No Notes Found!</div>
</div>
